import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Branch } from '@pos-app/data';
import { OverrideData } from '../../+state/orders.models';
import { NgSelectComponent, NgOptionComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-orders-override-branch',
    templateUrl: './orders-override-branch.component.html',
    styleUrls: ['./orders-override-branch.component.scss'],
    imports: [NgSelectComponent, FormsModule, NgFor, NgOptionComponent, NgIf]
})
export class OrdersOverrideBranchComponent implements OnInit {
  @Input() shipTo: string;
  @Input() branch: string;
  @Input() isConvertToOrder: boolean;
  @Input() branchList: Branch[];
  @Input() overridenBranch: string;
  @Output() selectOverridenBranch = new EventEmitter<OverrideData>();

  constructor() {}

  ngOnInit() {}

  onSelectBranch() {
    this.selectOverridenBranch.emit({
      overrideBranch: this.overridenBranch,
      overrideSalesPerson: null,
      overrideShipTo: null,
      nonCorpStoreSaleYN: null,
    });
  }

  onCancel() {
    this.selectOverridenBranch.emit(null);
  }
}

